/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { DeleteConfirmationModal } from '../../widgets/components/DeleteConfirmationModal'
import { useState } from 'react'
import { deleteDataRoom, cloneDataRoom } from '../core/_requests'
import { toast } from 'react-toastify'
import { CopyConfirmationModal } from '../../investor-updates/views/CopyConfirmationModal'
import { useMoveToFolderData } from '../core/FileToFolderAuth'
import { useAuth } from '../../auth'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import { useThemeMode } from '../../../../_metronic/partials'

export function DataRoomDropdown({
  isOpen,
  dataRoomId,
  showDeleteModal,
  showCloneModal,
  setDeleteShowModal,
  setCloneShowModal,
  getAllDataRoomsById,
  setdataRoomId,
  status,
}: {
  isOpen: boolean
  dataRoomId: number
  showDeleteModal?: any
  showCloneModal?: any
  setDeleteShowModal?: any
  setCloneShowModal?: any
  getAllDataRoomsById: any
  setdataRoomId?: any
  status: string
}) {
  const { formatMessage } = useIntl()
  const { mode } = useThemeMode()
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [cloneLoading, setCloneLoading] = useState(false)
  const { setShareDrawer } = useMoveToFolderData()
  const { companyId, currentUser } = useAuth()

  const handleDeleteDataRoom = async (dataRoomId: number) => {
    try {
      setDeleteLoading(true)
      if (dataRoomId) {
        const {
          data: { success, errors },
        } = await deleteDataRoom(dataRoomId)
        if (success) {
          setDeleteLoading(false)
          setDeleteShowModal(false)
          toast.success(formatMessage({ id: 'Data Room deleted successfully' }))
          getAllDataRoomsById()
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DeleteDataRoomSuccessful,
              action: 'normal',
              metadata: {
                dataroom_id: dataRoomId,
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
              },
            },
          })
        } else {
          setDeleteLoading(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DeleteDataRoomFailed,
              action: 'normal',
              metadata: {
                dataroom_id: dataRoomId,
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      setDeleteLoading(false)
      console.log(err)
    }
  }

  const handleCloneDataRoom = async () => {
    try {
      setCloneLoading(true)
      if (dataRoomId) {
        const {
          data: { success, errors },
        } = await cloneDataRoom(dataRoomId)
        if (success) {
          setCloneShowModal(false)
          toast.success(formatMessage({ id: 'Data Room cloned successfully' }))
          getAllDataRoomsById()
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DataRoomClonedSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                cloned_dataroom_id: dataRoomId
              },
            },
          })
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DataRoomClonedFailed,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                cloned_dataroom_id: dataRoomId,
                error: errors[0]
              },
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setCloneLoading(false)
    }
  }

  return (
    <>
      {isOpen ? (
        <>
          <div className={`menu menu-sub menu-sub-dropdown data-room-option-dropdown${mode === 'dark' ? '-dark' : ''} show`}>
            {status === 'PUBLISHED' && (
              <div
                className={`option-padding${mode === 'dark' ? '-dark' : ''}`}
                onClick={() => {
                  setdataRoomId(dataRoomId)
                  setShareDrawer(true)
                }}
              >
                <p className='mb-0 text-dark'>{formatMessage({ id: 'Share' })}</p>
              </div>
            )}

            <div className='separator border-gray-200'></div>

            <Link to={`/data-rooms/space-edit/all-files/${dataRoomId}`} className={`option-padding${mode === 'dark' ? '-dark' : ''}`}>
              <p className='mb-0 text-dark'>{formatMessage({ id: 'Edit' })}</p>
            </Link>

            <div className='separator border-gray-200'></div>

            <div className='separator border-gray-200'></div>

            <div className={`option-padding${mode === 'dark' ? '-dark' : ''}`} onClick={() => setCloneShowModal(true)}>
              <p className='mb-0 text-dark'>{formatMessage({ id: 'Duplicate Data Room' })}</p>
            </div>

            <div className='separator border-gray-200'></div>

            <div className={`option-padding${mode === 'dark' ? '-dark' : ''}`} onClick={() => setDeleteShowModal(true)}>
              <p className='mb-0 text-danger'>{formatMessage({ id: 'Delete Data Room' })}</p>
            </div>
          </div>
        </>
      ) : null}
      <DeleteConfirmationModal
        showDeleteModal={showDeleteModal}
        setDeleteShowModal={setDeleteShowModal}
        headingMessage={formatMessage({ id: 'Delete Data Room' })}
        description={formatMessage({ id: 'Are you sure you want to delete this Data Room?' })}
        handleDelete={handleDeleteDataRoom}
        deleteLoading={deleteLoading}
        id={+dataRoomId}
      />
      <CopyConfirmationModal
        copyHeader={formatMessage({ id: 'Clone Data Room' })}
        copyDiscription={formatMessage({ id: 'Are you sure you want to clone this Data Room?' })}
        showMakeACopyModal={showCloneModal}
        setMakeACopyShowModal={setCloneShowModal}
        onCopySubmit={handleCloneDataRoom}
        makeACopyLoading={cloneLoading}
      />
    </>
  )
}
